"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _UIButton = _interopRequireDefault(require("../../button/UIButton"));

var _UIClickable = _interopRequireDefault(require("../../button/UIClickable"));

var _Tether = require("../../constants/Tether");

var _Functions = require("../../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _ShareButton = _interopRequireDefault(require("../../decorators/ShareButton"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _focusStylesListener = require("../../listeners/focusStylesListener");

var _PlacementConstants = require("../../tooltip/PlacementConstants");

var _UIControlledPopover = _interopRequireDefault(require("../../tooltip/UIControlledPopover"));

var _UIPopoverArrow = _interopRequireDefault(require("../../tooltip/internal/UIPopoverArrow"));

var CustomRenderer = _interopRequireWildcard(require("../../utils/propTypes/customRenderer"));

var _decorators = require("../../utils/propTypes/decorators");

var _iconName = require("../../utils/propTypes/iconName");

var _refObject = _interopRequireDefault(require("../../utils/propTypes/refObject"));

var _tshirtSize = require("../../utils/propTypes/tshirtSize");

var _Timers = require("../../utils/Timers");

var _underscore = require("../../utils/underscore");

var _UIDropdownCaret = _interopRequireDefault(require("../UIDropdownCaret"));

var getArrowSize = function getArrowSize(buttonUse) {
  if (buttonUse.match(/link|transparent/)) {
    return 'medium';
  }

  return 'none';
};

var getPlacement = function getPlacement(placement, computedArrowSize) {
  if (placement) {
    return placement;
  } // Center if we have an arrow, otherwise flush left against the target


  if (computedArrowSize !== 'none') {
    return 'bottom';
  }

  return 'bottom right';
};

var getDistanceAdjustment = function getDistanceAdjustment(buttonSize, buttonUse) {
  if (buttonUse === 'transparent') {
    // Account for invisible padding
    var shorthandSize = (0, _tshirtSize.toShorthandSize)(buttonSize);
    var buttonPaddingY;

    if (shorthandSize === 'xs') {
      buttonPaddingY = _sizes.BUTTON_XS_PADDING_Y;
    } else if (shorthandSize === 'sm') {
      buttonPaddingY = _sizes.BUTTON_SM_PADDING_Y;
    } else {
      buttonPaddingY = _sizes.BUTTON_DEFAULT_PADDING_Y;
    }

    return -parseInt(buttonPaddingY, 10);
  }

  return 0;
};

var getInsetAdjustment = function getInsetAdjustment(buttonUse, placement, computedArrowSize) {
  if (buttonUse === 'transparent' && placement === 'bottom right' && computedArrowSize === 'none') {
    // Account for invisible padding. Inset adjustments are applied twice
    // (once to the tether attachment, once to the target attachment), so
    // we halve our value here.
    return -parseInt(_sizes.BUTTON_DEFAULT_PADDING_X, 10) / 2;
  }

  return 0;
};

var getButtonClassName = function getButtonClassName(className, multiline, open, readOnly) {
  return (0, _classnames.default)(className, 'private-button__dropdown-opener', 'uiDropdown__button', {
    'private-button__dropdown-opener--multiline': multiline,
    'private-button__dropdown-opener--open': open,
    // a 'readonly' <button> doesn't make sense, so apply class for styling here
    'private-button--readonly': readOnly
  });
};

var getStyle = function getStyle(menuWidth, controlWidth) {
  return {
    width: menuWidth || controlWidth,
    minWidth: menuWidth === 'auto' ? controlWidth : null
  };
};

var renderButtonLabel = function renderButtonLabel(buttonText, iconName, readOnly) {
  var buttonClassNames = (0, _classnames.default)('private-dropdown__button-label', 'uiDropdown__buttonLabel', {
    'private-dropdown__button-label--no-icon': !iconName && !buttonText || readOnly
  });
  var icon = iconName ? _react.default.createElement(_UIIcon.default, {
    className: "private-dropdown__icon",
    name: iconName
  }) : null;
  return _react.default.createElement("span", {
    className: buttonClassNames
  }, icon, buttonText == null || buttonText === '' ? "\u200B" : buttonText);
};

var UIAbstractDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIAbstractDropdown, _Component);

  function UIAbstractDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAbstractDropdown).call(this, props));
    _this.state = {
      controlWidth: 0
    };

    _this.measureControlWidth = function () {
      // Make the menu width match up with the anchor width
      var _this$props = _this.props,
          buttonRef = _this$props.buttonRef,
          open = _this$props.open;
      var controlEl = buttonRef.current;

      if (controlEl && open) {
        var controlWidth = _this.computeControlWidth(controlEl);

        if (controlWidth !== _this.state.controlWidth) {
          _this.setState({
            controlWidth: controlWidth
          });
        }
      }
    };

    _this.hasKeyboardFocus = function () {
      var buttonRef = _this.props.buttonRef;
      var activeElement = document.activeElement;
      var dropdownNode = document.getElementById(_this._contentId);

      if (!activeElement) {
        return false;
      }

      if (activeElement === buttonRef.current) {
        return true;
      } else if (dropdownNode && dropdownNode.contains(activeElement)) {
        return true;
      }

      return false;
    };

    _this.handleButtonClick = function (evt) {
      var _this$props2 = _this.props,
          locked = _this$props2.locked,
          open = _this$props2.open,
          onClick = _this$props2.onClick;
      (0, _Functions.callIfPossible)(onClick, evt);

      if (!locked) {
        var nextOpen = !open;

        _this.setIsOpen(nextOpen);
      }
    };

    _this.shouldCloseOnClick = function (evt) {
      var _this$props3 = _this.props,
          buttonRef = _this$props3.buttonRef,
          shouldCloseOnClick = _this$props3.shouldCloseOnClick; // If `shouldCloseOnClick` is provided and returns a non-null value, defer to it

      if (shouldCloseOnClick) {
        var shouldClose = shouldCloseOnClick(evt);
        if (shouldClose != null) return shouldClose;
      }

      var target = evt.target;
      var controlNode = buttonRef.current;
      if (!controlNode) return null; // Ignore clicks on any <label> that contain the button

      var parentEl = controlNode;

      while (parentEl.parentElement) {
        parentEl = parentEl.parentElement;

        if (parentEl.tagName === 'LABEL' && parentEl.contains(target)) {
          return false;
        }
      } // Ignore clicks on any <label> whose "for" attr points to the button


      var id = controlNode.id;

      if (id) {
        var labelsForControl = document.querySelectorAll("label[for=\"" + id + "\"]");

        for (var i = 0; i < labelsForControl.length; i++) {
          if (labelsForControl[i].contains(target)) {
            return false;
          }
        }
      }

      return null;
    };

    _this.handleWindowResize = function () {
      (0, _Timers.cancelSchedulerCallback)(_this._resizeFrame);
      _this._resizeFrame = (0, _Timers.requestSchedulerCallback)(_this.measureControlWidth);
    };

    _this.handleKeyDown = function (evt) {
      // Handle keydown events from both the button and the dropdown
      var _this$props4 = _this.props,
          onKeyDown = _this$props4.onKeyDown,
          open = _this$props4.open;

      if (open && evt.key === 'Escape') {
        _this.setIsOpen(false);

        evt.stopPropagation();
      }

      (0, _Functions.callIfPossible)(onKeyDown, evt);
    };

    _this.setIsOpen = function (nextOpen) {
      var _this$props5 = _this.props,
          onOpenChange = _this$props5.onOpenChange,
          readOnly = _this$props5.readOnly;

      if (!onOpenChange || readOnly) {
        return;
      }

      onOpenChange((0, _SyntheticEvent.default)(nextOpen));
    };

    _this.focusOnControl = function () {
      // When focusing, reset the scroll coordinates to negate the browser's scroll behavior
      var buttonRef = _this.props.buttonRef;
      var _document$documentEle = document.documentElement,
          scrollLeft = _document$documentEle.scrollLeft,
          scrollTop = _document$documentEle.scrollTop;
      var controlNode = buttonRef.current;
      if (!controlNode) return;
      controlNode.focus();
      scrollTo(scrollLeft, scrollTop);
    };

    _this.computeControlWidth = function (controlEl) {
      var open = _this.props.open;

      if (!controlEl || !open) {
        return 0;
      }

      var exactWidth = controlEl.getBoundingClientRect().width;
      var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
      return roundedWidth - 2; // account for 1px border added by UIPopover
    };

    _this.renderContent = function () {
      var _this$props6 = _this.props,
          children = _this$props6.children,
          Content = _this$props6.Content,
          dropdownClassName = _this$props6.dropdownClassName,
          dropdownContentRef = _this$props6.dropdownContentRef,
          menuWidth = _this$props6.menuWidth,
          minMenuWidth = _this$props6.minMenuWidth;
      var controlWidth = Math.max(_this.state.controlWidth, minMenuWidth);
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('private-dropdown', 'uiDropdown__dropdown', dropdownClassName),
        id: _this._contentId,
        onKeyDown: _this.handleKeyDown,
        ref: dropdownContentRef,
        role: "presentation",
        style: _this._getStyle(menuWidth, controlWidth)
      }, Content ? _react.default.createElement(Content, null) : children);
    };

    _this._buttonId = (0, _underscore.uniqueId)('uiabstractdropdown-button-');
    _this._contentId = (0, _underscore.uniqueId)('uiabstractdropdown-content-');
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this.popoverRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(UIAbstractDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var open = this.props.open;

      if (open) {
        this.measureControlWidth();
        addEventListener('resize', this.handleWindowResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var open = this.props.open; // ⚠️ This condition prevents infinite loops! ⚠️

      if (prevState.controlWidth === this.state.controlWidth) {
        this.measureControlWidth();
      } // If the dropdown was closed via the keyboard, and the focus was within the dropdown, then give
      // keyboard focus to the control.


      if (prevProps.open && !open && this.hasKeyboardFocus() && (0, _focusStylesListener.isPageInKeyboardMode)()) {
        this.focusOnControl();
      }

      if (!prevProps.open && open) {
        addEventListener('resize', this.handleWindowResize);
      } else if (prevProps.open && !open) {
        removeEventListener('resize', this.handleWindowResize);
        (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeEventListener('resize', this.handleWindowResize);
      (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          animateOnMount = _this$props7.animateOnMount,
          animateOnToggle = _this$props7.animateOnToggle,
          ariaExpanded = _this$props7['aria-expanded'],
          ariaLabelledby = _this$props7['aria-labelledby'],
          arrowColor = _this$props7.arrowColor,
          arrowSize = _this$props7.arrowSize,
          autoPlacement = _this$props7.autoPlacement,
          Button = _this$props7.Button,
          buttonRef = _this$props7.buttonRef,
          buttonSize = _this$props7.buttonSize,
          buttonText = _this$props7.buttonText,
          buttonUse = _this$props7.buttonUse,
          caretRenderer = _this$props7.caretRenderer,
          __children = _this$props7.children,
          className = _this$props7.className,
          closeOnOutsideClick = _this$props7.closeOnOutsideClick,
          closeOnTargetLeave = _this$props7.closeOnTargetLeave,
          __Content = _this$props7.Content,
          __dropdownClassName = _this$props7.dropdownClassName,
          __dropdownContentRef = _this$props7.dropdownContentRef,
          iconName = _this$props7.iconName,
          id = _this$props7.id,
          __locked = _this$props7.locked,
          __menuWidth = _this$props7.menuWidth,
          __minMenuWidth = _this$props7.minMenuWidth,
          multiline = _this$props7.multiline,
          onChangePlacement = _this$props7.onChangePlacement,
          __onClick = _this$props7.onClick,
          onFocusLeave = _this$props7.onFocusLeave,
          onOpenChange = _this$props7.onOpenChange,
          onOpenComplete = _this$props7.onOpenComplete,
          onOpenStart = _this$props7.onOpenStart,
          open = _this$props7.open,
          pinToConstraint = _this$props7.pinToConstraint,
          placement = _this$props7.placement,
          popoverRef = _this$props7.popoverRef,
          popoverProps = _this$props7.popoverProps,
          readOnly = _this$props7.readOnly,
          __shouldCloseOnClick = _this$props7.shouldCloseOnClick,
          _useNativeButton = _this$props7._useNativeButton,
          rest = (0, _objectWithoutProperties2.default)(_this$props7, ["animateOnMount", "animateOnToggle", "aria-expanded", "aria-labelledby", "arrowColor", "arrowSize", "autoPlacement", "Button", "buttonRef", "buttonSize", "buttonText", "buttonUse", "caretRenderer", "children", "className", "closeOnOutsideClick", "closeOnTargetLeave", "Content", "dropdownClassName", "dropdownContentRef", "iconName", "id", "locked", "menuWidth", "minMenuWidth", "multiline", "onChangePlacement", "onClick", "onFocusLeave", "onOpenChange", "onOpenComplete", "onOpenStart", "open", "pinToConstraint", "placement", "popoverRef", "popoverProps", "readOnly", "shouldCloseOnClick", "_useNativeButton"]);
      var computedArrowSize = arrowSize || getArrowSize(buttonUse);
      var computedButtonClassName = getButtonClassName(className, multiline, open, readOnly);
      var computedPlacement = getPlacement(placement, computedArrowSize);
      var computedDistanceAdjustment = getDistanceAdjustment(buttonSize, buttonUse);
      var computedInsetAdjustment = getInsetAdjustment(buttonUse, placement, computedArrowSize);
      var renderedButtonLabel = renderButtonLabel(buttonText, iconName, readOnly);
      var renderedCaret = CustomRenderer.render(caretRenderer, {
        use: buttonUse
      });
      var ButtonType = Button || (buttonUse === 'unstyled' ? _UIClickable.default : _UIButton.default);
      var buttonProps = buttonUse === 'unstyled' ? {} : {
        _useNativeButton: _useNativeButton,
        size: buttonSize,
        use: buttonUse
      };
      var buttonId = id || this._buttonId; // UIDatePicker: allow setting aria-expanded={true} when open={false}

      var computedAriaExpanded = !!(ariaExpanded != null ? ariaExpanded : open) || undefined;
      return _react.default.createElement(_UIControlledPopover.default, Object.assign({
        animateOnMount: animateOnMount,
        animateOnToggle: animateOnToggle,
        arrowColor: arrowColor,
        arrowSize: computedArrowSize,
        autoPlacement: autoPlacement,
        closeOnOutsideClick: closeOnOutsideClick,
        closeOnTargetLeave: closeOnTargetLeave,
        Content: this.renderContent,
        _distanceAdjustment: computedDistanceAdjustment,
        _insetAdjustment: computedInsetAdjustment,
        onFocusLeave: onFocusLeave,
        onChangePlacement: onChangePlacement,
        onOpenChange: onOpenChange,
        onOpenStart: onOpenStart,
        onOpenComplete: onOpenComplete,
        open: open,
        pinToConstraint: pinToConstraint,
        placement: computedPlacement,
        popoverRef: popoverRef || this.popoverRef,
        shouldCloseOnClick: this.shouldCloseOnClick
      }, popoverProps), _react.default.createElement(ButtonType, Object.assign({}, rest, buttonProps, {
        "aria-expanded": computedAriaExpanded,
        "aria-haspopup": true,
        "aria-labelledby": ariaLabelledby ? ariaLabelledby + " " + buttonId : buttonId,
        "aria-owns": this._contentId,
        className: computedButtonClassName,
        "data-dropdown-open": open,
        id: buttonId,
        onClick: this.handleButtonClick,
        onKeyDown: this.handleKeyDown,
        buttonRef: buttonRef
      }), _react.default.createElement("span", {
        className: "uiDropdown__buttonContents private-dropdown__button__contents"
      }, renderedButtonLabel, !readOnly && renderedCaret)));
    }
  }]);
  return UIAbstractDropdown;
}(_react.Component);

UIAbstractDropdown.propTypes = {
  animateOnMount: _propTypes.default.bool.isRequired,
  animateOnToggle: _propTypes.default.bool,
  'aria-expanded': (0, _decorators.hidden)(_propTypes.default.bool),
  'aria-labelledby': _propTypes.default.string,
  arrowColor: _propTypes.default.string,
  arrowSize: _propTypes.default.oneOf(Object.keys(_UIPopoverArrow.default.ARROW_SIZES)),
  autoPlacement: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['horiz', 'vert'])]).isRequired,
  Button: _propTypes.default.elementType,
  buttonRef: _refObject.default.isRequired,
  buttonSize: _UIButton.default.propTypes.size,
  buttonText: _propTypes.default.node,
  buttonUse: _UIDropdownCaret.default.propTypes.use,
  caretRenderer: CustomRenderer.propType,
  children: _propTypes.default.node,
  closeOnOutsideClick: _propTypes.default.bool,
  closeOnTargetLeave: _propTypes.default.bool,
  Content: _propTypes.default.elementType,
  disabled: _propTypes.default.bool,
  dropdownClassName: _propTypes.default.string,
  dropdownContentRef: (0, _decorators.hidden)(_propTypes.default.func),
  iconName: (0, _iconName.getIconNamePropType)(),
  locked: _propTypes.default.bool.isRequired,
  menuWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
  minMenuWidth: _propTypes.default.number.isRequired,
  multiline: (0, _decorators.hidden)(_propTypes.default.bool.isRequired),
  onChangePlacement: _propTypes.default.func,
  onFocusLeave: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  pinToConstraint: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]),
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS),
  popoverRef: _refObject.default,
  popoverProps: _propTypes.default.object,
  readOnly: _propTypes.default.bool,
  shouldCloseOnClick: _propTypes.default.func,
  _useNativeButton: _propTypes.default.bool
};
UIAbstractDropdown.defaultProps = {
  animateOnMount: false,
  autoPlacement: 'vert',
  buttonSize: 'default',
  buttonUse: 'secondary',
  caretRenderer: _react.default.createElement(_UIDropdownCaret.default, null),
  closeOnOutsideClick: true,
  dropdownClassName: '',
  locked: false,
  minMenuWidth: _Tether.MIN_MENU_WIDTH,
  multiline: false,
  open: false
};
UIAbstractDropdown.displayName = 'UIAbstractDropdown';

var _default = (0, _ShareButton.default)(UIAbstractDropdown);

exports.default = _default;
module.exports = exports.default;